import React from 'react';
import '../../layout/frontlayout/css/bg_regular.css';
import '../../layout/frontlayout/css/frontBox.css';
import Footer from './Footer'
import Login from '../../pages/Login';
import Header from './Header';
import InterSite from './InterSite';
import SignUp from './SignUp';
import ViewDemo from './ViewDemo';


function Frontlayout() {
    return (
        <>
            <audio id="beep" controls preload="auto" hidden="true" style={{ display: 'none !important' }}>
                <source src="swf/assets/sound/rollover.mp3" type="audio/mpeg" />
                <source src="swf/assets/sound/rollover.wav" type="audio/wav" />
            </audio>
            <div id="outer-container">

                <div id="loading-container" >
                    <div className="container">
                        <p className="tagline-p">OPEN <span className="highlightGreen">PLAY</span><br />TENNIS</p>
                    </div>
                </div>
                <div id="main-container">
                    <div id="main">
                        <div className="container">
                            <Header />
                            <div className="clear"></div>
                            <div id="site_content">
                                <div className="sidebar-menu">
                                    <nav id="nav-common" style={{ height: '0px', width: '0px' }} className="menubg">
                                        <ul id="sidemenu-fixed" className="menu">
                                        </ul>
                                        <Login />
                                        <InterSite />
                                        <SignUp />
                                    </nav>
                                </div>
                                <ViewDemo />

                            </div>
                            {/* <div className="homeDefault-socail">
                                <div id="links" className="text-right">
                                    <a className="ie-post-link" onclick="showLink('http://www.facebook.com/pages/City-Golf-League/348284351925121');">
                                        <i className="fa fa-facebook"></i>
                                    </a>
                                    <a className="ie-post-link" onclick="showLink('https://twitter.com/CityGolfLeague');">
                                        <i className="fa fa-twitter"></i>
                                    </a>
                                    <a href="#" target="_blank"><i className="fa fa-instagram"></i></a>
                                </div>
                            </div> */}
                        </div>
                    </div>

                </div>
            </div>
            <Footer />

        </>
    )
}

export default Frontlayout;